import Flex from '@Components/Bases/Flex';
import { CloudDownloadOutlined } from '@mui/icons-material';
import {
  Alert,
  AlertProps,
  Box,
  BoxProps,
  Button,
  Typography,
} from '@mui/material';

type DownloadFileProps = {
  label?: string;
  publishDate?: string;
  onDownload?: () => void;
  loading?: boolean;
  disabled?: boolean;
  url?: string | null;
  severity?: AlertProps['severity'];
  alertMessage?: string;
} & BoxProps;

const DownloadFile = (props: DownloadFileProps) => {
  const {
    label,
    publishDate,
    onDownload,
    loading,
    disabled,
    url,
    alertMessage: errorMessage,
    severity = 'info',
    ...restProps
  } = props;

  const showError = url === null || severity === 'error';

  return (
    <Box
      {...restProps}
      border={'1px solid hsla(240, 2%, 90%, 1)'}
      borderRadius={1}
    >
      <Typography
        p={1}
        borderBottom={'1px solid hsla(240, 2%, 90%, 1)'}
        fontWeight={800}
      >
        {label}
      </Typography>

      {showError && (
        <Box p={2} pb={0}>
          <Alert severity={severity}>
            <Typography>{errorMessage}</Typography>
          </Alert>
        </Box>
      )}

      <Flex
        justifyContent={'center'}
        flexDirection={'column'}
        p={2}
        alignItems={'center'}
      >
        <Button
          variant="text"
          color="info"
          endIcon={<CloudDownloadOutlined />}
          onClick={onDownload}
          disabled={disabled || showError}
          loading={loading}
        >
          ดาวน์โหลดเอกสาร
        </Button>
        <Typography>เผยแพร่เมื่อ {publishDate ? publishDate : '-'}</Typography>
      </Flex>
    </Box>
  );
};

export default DownloadFile;
